import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Play, Award, Info, Settings } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center mr-3">
                <span className="font-bold text-lg">ئۇ</span>
              </div>
              <h1 className="text-xl font-bold text-emerald-600 hidden md:block">
                ئۇيغۇرچە سۆز زەنجىرى
              </h1>
            </Link>
          </div>
          
          <nav className="flex items-center space-x-1 md:space-x-2">
            <Link 
              to="/" 
              className={`p-2 rounded-lg flex flex-col items-center text-xs ${
                isActive('/') 
                  ? 'bg-emerald-100 text-emerald-700' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Home size={20} />
              <span>باش بەت</span>
            </Link>
            
            <Link 
              to="/game" 
              className={`p-2 rounded-lg flex flex-col items-center text-xs ${
                isActive('/game') 
                  ? 'bg-emerald-100 text-emerald-700' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Play size={20} />
              <span>ئويناش</span>
            </Link>
            
            <Link 
              to="/leaderboard" 
              className={`p-2 rounded-lg flex flex-col items-center text-xs ${
                isActive('/leaderboard') 
                  ? 'bg-emerald-100 text-emerald-700' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Award size={20} />
              <span>رېكورد</span>
            </Link>
            
            <Link 
              to="/about" 
              className={`p-2 rounded-lg flex flex-col items-center text-xs ${
                isActive('/about') 
                  ? 'bg-emerald-100 text-emerald-700' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Info size={20} />
              <span>ھەققىدە</span>
            </Link>
            
            <Link 
              to="/settings" 
              className={`p-2 rounded-lg flex flex-col items-center text-xs ${
                isActive('/settings') 
                  ? 'bg-emerald-100 text-emerald-700' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Settings size={20} />
              <span>تەڭشەكلەر</span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;